/* ============================================================
   ALLURING CREATIONS BOUTIQUE — Theme JavaScript
   Gravity Studio | Vanilla JS, no dependencies
   ============================================================ */
(function () {
  'use strict';

  /* ---- Sticky header shadow ---- */
  var header = document.getElementById('gs-ac-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('ac-scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ---- Scroll reveal with feature-detect fallback ---- */

  /* En el editor del tema: mostrar todo inmediatamente y re-aplicar al recargar secciones */
  if (window.Shopify && window.Shopify.designMode) {
    function showAllReveals(root) {
      (root || document).querySelectorAll('.ac-reveal').forEach(function (el) {
        el.classList.add('ac-in');
      });
    }
    showAllReveals();
    document.addEventListener('shopify:section:load', function (e) {
      showAllReveals(e.target);
    });
    document.addEventListener('shopify:section:select', function (e) {
      showAllReveals(e.target);
    });
  } else {
    /* Sitio en vivo: animación normal por scroll */
    var revealEls = Array.from(document.querySelectorAll('.ac-reveal'));

    function checkReveal() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = revealEls.length - 1; i >= 0; i--) {
        var el = revealEls[i];
        var r = el.getBoundingClientRect();
        if (r.top < vh - 60 && r.bottom > 0) {
          el.classList.add('ac-in');
          revealEls.splice(i, 1);
        }
      }
    }

    /* Re-observar elementos cuando el editor recarga secciones */
    document.addEventListener('shopify:section:load', function (e) {
      var newEls = Array.from(e.target.querySelectorAll('.ac-reveal'));
      newEls.forEach(function (el) { revealEls.push(el); });
      checkReveal();
    });

    /* Probe whether CSS transitions animate; if not, show all statically */
    var probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;left:-9999px;top:0;width:6px;height:6px;opacity:0;transition:opacity .06s linear;pointer-events:none;';
    document.body.appendChild(probe);
    void probe.offsetWidth;
    probe.style.opacity = '1';
    setTimeout(function () {
      var moved = parseFloat(getComputedStyle(probe).opacity) > 0.5;
      probe.remove();
      if (moved) {
        window.addEventListener('scroll', checkReveal, { passive: true });
        window.addEventListener('resize', checkReveal);
        checkReveal();
      } else {
        document.documentElement.classList.add('ac-no-anim');
      }
    }, 160);
  }

  /* ---- Mobile drawer ---- */
  var drawer = document.getElementById('gs-ac-drawer');
  var menuToggle = document.getElementById('gs-ac-menu-toggle');
  var drawerClose = document.getElementById('gs-ac-drawer-close');

  if (drawer && menuToggle) {
    menuToggle.addEventListener('click', function () {
      drawer.classList.add('ac-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (drawer && drawerClose) {
    drawerClose.addEventListener('click', function () {
      drawer.classList.remove('ac-open');
      document.body.style.overflow = '';
    });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.tagName === 'A') {
        drawer.classList.remove('ac-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---- Sparkle generator (hero) ---- */
  function makeSparkles(container, n) {
    if (!container) return;
    var svgStar = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 0c1 6 5 10 12 12-7 2-11 6-12 12-1-6-5-10-12-12C7 10 11 6 12 0Z"/></svg>';
    for (var i = 0; i < n; i++) {
      var s = document.createElement('div');
      s.className = 'ac-sparkle';
      var size = 6 + Math.random() * 16;
      s.style.width = size + 'px';
      s.style.height = size + 'px';
      s.style.left = Math.random() * 100 + '%';
      s.style.top = Math.random() * 100 + '%';
      s.style.setProperty('--ac-dur', (3.5 + Math.random() * 4) + 's');
      s.style.setProperty('--ac-delay', (Math.random() * 5) + 's');
      s.innerHTML = svgStar;
      container.appendChild(s);
    }
  }

  makeSparkles(document.getElementById('gs-ac-hero-fx'), 18);

  /* ---- Light motes generator (verse section) ---- */
  var verseGlow = document.getElementById('gs-ac-verse-glow');
  if (verseGlow) {
    for (var i = 0; i < 18; i++) {
      var m = document.createElement('div');
      m.className = 'ac-mote';
      var s = 3 + Math.random() * 5;
      m.style.width = s + 'px';
      m.style.height = s + 'px';
      m.style.left = Math.random() * 100 + '%';
      m.style.animationDuration = (7 + Math.random() * 7) + 's';
      m.style.animationDelay = (-Math.random() * 12) + 's';
      verseGlow.appendChild(m);
    }
  }

  /* ---- Frame glint (Meet Lizette scroll-driven) ---- */
  var meetSec = document.getElementById('gs-ac-meet');
  var meetFrame = meetSec ? meetSec.querySelector('.ac-frame') : null;
  if (meetFrame) {
    var ticking = false;
    function updateGlint() {
      ticking = false;
      var r = meetSec.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var total = r.height + vh;
      var p = (vh - r.top) / total;
      p = Math.max(0, Math.min(1, p));
      meetFrame.style.setProperty('--ac-glint', (p * 540).toFixed(1) + 'deg');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateGlint);
      }
    }, { passive: true });
    window.addEventListener('resize', updateGlint);
    updateGlint();
  }

  /* ---- Featured products: Add to Cart (homepage demo → Shopify cart) ---- */
  document.querySelectorAll('.ac-prod-add-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.ac-prod-add');
      if (!btn) return;
      var variantId = form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null;
      if (!variantId) return;

      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = 'Added ♥';
          btn.style.background = 'var(--ac-rose)';
          btn.style.color = '#fff';
          /* Update cart count badge */
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var badge = document.querySelector('.ac-cart-count');
          if (badge) badge.textContent = cart.item_count;
        })
        .catch(function () {
          btn.textContent = 'Error';
        })
        .finally(function () {
          setTimeout(function () {
            btn.textContent = original;
            btn.style.background = '';
            btn.style.color = '';
            btn.disabled = false;
          }, 1200);
        });
    });
  });

  /* ---- Gallery masonry (grid row-span, avoids CSS-columns top-gap bug) ---- */
  var galleryGrids = document.querySelectorAll('.ac-gallery-masonry');
  if (galleryGrids.length) {
    var layoutMasonry = function (grid) {
      var styles = getComputedStyle(grid);
      var rowHeight = parseFloat(styles.gridAutoRows) || 6;
      var rowGap = parseFloat(styles.rowGap) || 0;
      Array.prototype.forEach.call(grid.children, function (item) {
        var img = item.querySelector('img');
        var itemWidth = item.getBoundingClientRect().width;
        var renderedHeight;
        if (img && img.naturalWidth && img.naturalHeight) {
          renderedHeight = itemWidth * (img.naturalHeight / img.naturalWidth);
        } else if (img && img.width && img.height) {
          renderedHeight = itemWidth * (img.height / img.width);
        } else {
          renderedHeight = itemWidth;
        }
        var span = Math.ceil((renderedHeight + rowGap) / (rowHeight + rowGap));
        item.style.gridRowEnd = 'span ' + span;
      });
    };

    var layoutAllMasonry = function (root) {
      var grids = (root || document).querySelectorAll('.ac-gallery-masonry');
      Array.prototype.forEach.call(grids, layoutMasonry);
    };

    layoutAllMasonry();
    window.addEventListener('load', function () { layoutAllMasonry(); });

    var masonryResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(masonryResizeTimer);
      masonryResizeTimer = setTimeout(function () { layoutAllMasonry(); }, 150);
    });

    document.addEventListener('shopify:section:load', function (e) {
      layoutAllMasonry(e.target);
    });
  }

})();
